<template>
  <div class="gallery page">
    <div class="search-wrapper">
      <div class="search">
        <SearchByTag></SearchByTag>
      </div>
    </div>
    <UiDataBox :loading="loading" :isEmpty="isEmpty" :error="error">

      <AlbumList :items="albums"></AlbumList>

      <Pagination
        :total="pagination.total"
        :limit="pagination.limit"
        :page.sync="pagination.page">
      </Pagination>

    </UiDataBox>
  </div>
</template>

<script>
  import * as albumsService from '../../services/albums.service'

  import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
  import Pagination from '../../components/Pagination.vue'
  import SearchByTag from '../../components/SearchByTag.vue'
  import AlbumList from './AlbumList.vue'

  export default {
    name: 'Gallery',
    props: {
      limit: {
        type: Number,
        default: 10
      },
      page: {
        type: Number,
        default: 0
      }
    },
    mixins: [prepareFetchParamsMixin],
    components: {
      Pagination,
      SearchByTag,
      AlbumList
    },

    watch: {
      'pagination.page': function () {
        this.fetchData()
      }
    },

    data () {
      return {
        loading: false,
        error: false,
        albums: [],
        searchQuery: '',
        pagination: {
          page: this.page,
          limit: this.limit,
          total: 0
        }
      }
    },

    methods: {
      fetchData () {
        this.loading = true
        albumsService.getListPublic(this.fetchParams)
          .then(response => {
            this.albums = response.data.content
            this.pagination.total = response.data.total
          }).catch(error => { this.error = error.message })
          .finally(() => { this.loading = false })
      }
    },

    computed: {
      fetchParams () {
        const pagination = this.prepareFetchParamsMixin({
          page: this.pagination.page,
          limit: this.pagination.limit
        })

        /*
        order example
        const order = this.prepareFetchParamsMixin({
          name: 'desc'
        })
        return { ...pagination, order }
        */

        return { ...pagination }
      },
      isEmpty () {
        return !this.albums.length
      }
    },

    created () {
      this.fetchData()
    }
  }
</script>

<style lang="scss">
  .gallery.page {
    .search-wrapper {
      display: flex;
      justify-content: flex-end;
      padding: 20px 10px;
      .search {
        width: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/gallery/Gallery.vue